import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import moment from 'moment/moment';


import './Resources/dashboard.css';
import axios from './../axios.js';
import Navbar from './Supportingfiles/navbar';
import Sidebar from './Supportingfiles/sidebar';
//import Create_cash from './create_cash';
import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';



import Chart from "chart.js/auto";
import { Line, Bar } from "react-chartjs-2";

//EXCEL DOWNLOAD IMPORT
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


function SP_admins(){


    //Invoice Print Function
    const componentRef = useref();
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    
    
 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const logname=sessionStorage.getItem("logName00");

 /* PAGE VARIABLES */


 
{/* TRANSACTIONS TABLE COLUMNS MANAGEMENT VARIABLES START */}
const[cd_col1_val,setcd_col1_val] = useState(0);//column1
const[cd_col2_val,setcd_col2_val] = useState(0);//column2
const[cd_col3_val,setcd_col3_val] = useState(0);//column3
const[cd_col4_val,setcd_col4_val] = useState(0);//column4
const[cd_col5_val,setcd_col5_val] = useState(0);//column5
const[cd_col6_val,setcd_col6_val] = useState(0);//column6
const[cd_col7_val,setcd_col7_val] = useState(0);//column7
const[cd_col8_val,setcd_col8_val] = useState(0);//column8
const[cd_col9_val,setcd_col9_val] = useState(0);//column9
const[cd_col10_val,setcd_col10_val] = useState(0);//column10
const[cd_col11_val,setcd_col11_val] = useState(0);//column11
const[cd_col12_val,setcd_col12_val] = useState(0);//column12
const[cd_col13_val,setcd_col13_val] = useState(0);//column13
const[cd_col14_val,setcd_col14_val] = useState(0);//column14 


//Variables for pagination
const [currentPage, setCurrentPage] = useState(1);
const [pageNumber, setpageNumber] = useState(1);

 
 //Error Variable
 const[errorvar,seterrorvar] = useState();


 //FILTER VARIABLES
//filter_val
const[filterval,setfilterval]=useState(0);
const[filter_code,setfilter_code]=useState();const updatefilter_code = (event) => { setfilter_code(event.target.value);}; const[filter_code_er,setfilter_code_er]=useState();
const[filter_username,setfilter_username]=useState();const updatefilter_username = (event) => { setfilter_username(event.target.value);}; const[filter_username_er,setfilter_username_er]=useState();
const[filter_name,setfilter_name]=useState();const updatefilter_name = (event) => { setfilter_name(event.target.value);}; const[filter_name_er,setfilter_name_er]=useState();


 
//Variables
const[data,setData] = useState([]);//SetData Variable


//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();


 useEffect(()=>{
   
  getData();
  
  },[])
 





//******************* GET ADMINS DATA FUNCTION START  ********************//
function getData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
 axios.post("adminlist", {
   Log_id:logid,
   Token:token,
   
   //Code Edits for pagination
   'page' : pageNumber,

   //Filters
   'Filter_val' :filterval,
   'Filter_code' :filter_code,
   'Filter_name' :filter_name,
   'Filter_username' :filter_username,
  // 'Filter_type' :filter_type,
  

   })
 .then((response) => {


  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("logName00");

     window.location.replace("/");
  }
  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
   setData(response.data.data.data);
  }

  //FILTER DATA
  //Validation Errors
  if(response.data.validatorerror){

    setfilter_code_er(response.data.validatorerror.Filter_code);
    setfilter_name_er(response.data.validatorerror.Filter_name);
    setfilter_username_er(response.data.validatorerror.Filter_username);
    //setfilter_type_er(response.data.validatorerror.Filter_type);
    seterrorvar("Validation error!");

  }

  //Data Violation
  if(response.data.error==102){ 
  
     //Setting Filter Violation Errors
     setfilter_code_er(response.data.filter_code_er);
     setfilter_name_er(response.data.filter_name_er);
     setfilter_username_er(response.data.filter_username_er);
    // setfilter_type_er(response.data.filter_type_er);
     seterrorvar("Violation Error");


  }


  //Cannot Fetch Data
  else{
   seterrorvar("Cannot Fetch Data !");
  }
 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("logName00");

   window.location.replace("/");
 
  }
 
 }
  
 //******************* GET ADMINS DATA FUNCTION END  ********************//



 


//******************* GET EXCEL DATA FUNCTION START  ********************//
function getexcelData(){
 

  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
 axios.post("adminlistinexcel", {
   Log_id:logid,
   Token:token,
   
   //Code Edits for pagination
   'page' : pageNumber,

   //Filters
   'Filter_val' :filterval,
   'Filter_code' :filter_code,
   'Filter_name' :filter_name,
   'Filter_username' :filter_username,
   //'Filter_type' :filter_type,

   })
 .then((response) => {


  //Invalid Session
  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("logName00");

     window.location.replace("/");
  }
  //Success Data Fetched
  if(response.data.successvar==1){
   //Setting Data
   const exceldata =response.data.data;
   
   // Convert JSON data to Excel worksheet
   const worksheet = XLSX.utils.json_to_sheet(exceldata);
   
   // Create a new workbook and add the worksheet
   const workbook = XLSX.utils.book_new();
   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
   
   // Convert the workbook to a binary array
   const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
   
   // Create a Blob from the binary data and trigger a download
   const excel_data = new Blob([excelBuffer], { type: "application/octet-stream" });
   saveAs(excel_data, "data.xlsx");
  }
  //Cannot Fetch Data
  else{
    seterrorvar("Cannot Download Excel File !");
  } 
 
 });
 
 }
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("logName00");

   window.location.replace("/");
 
  }
 
 }
  
 //******************* GET EXCEL DATA FUNCTION END  ********************//




return(
    <>
<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>ReactApp</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div className="container-scroller">

      <Sidebar />
    <div className="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div className="main-panel">

        

          <div className="content-wrapper pb-0">

          <div className="row">
              <div className="col-12 grid-margin create-form" id="create-form">
             {/*} <Create_cash /> */}
              </div>
          </div>


            <div className="page-header flex-wrap">
            <div className="header-left"></div>
              <div className="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div className="d-flex align-items-center">
                  <a href="#">
                    <p className="m-0 pe-3">SUPER ADMIN PANEL</p>
                  </a>
                  <a className="ps-3 me-4" href="#">
                    <p className="m-0">ADMINS</p>
                  </a>
                </div>
               
                <a href="/spadminpanel-dashboard-create-admin"><button type="button" className="btn btn-primary mt-2 mt-sm-0 btn-icon-text" >
                  <i className="mdi mdi-plus-circle"></i> Create New Admin </button></a>
              </div>
            </div>

            {/*} chart row starts here */}
            <div className="row">

          
            </div>

              {/* bpm TRANSACTIONS TABLE SECTION START */}
                  
             <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">ADMINS</h4>
                    <p className="card-description">manage admins
                    </p>
                    <code>{error_msg}</code>

                              {/* FILTER SECTION START */}
                              <hr/>
                            <div id="filter-top-card" class="row col-12" style={{textAlign:"left",display:"none"}}>
                            <div class="d-flex justify-content-between">
                            <div>
                            <h4 style={{padding:'1rem'}}>Filters</h4>
                           </div>
                           <div>
                    
                           <button type="button" class="btn btn-social-icon" onClick={()=>{ document.getElementById("filter-top-card").style.display="none"; }}>
                           <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                           </button>
                           </div>
                           </div>
        
                        <div class="row">
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Admin Code</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" placeholder="CODE001  " id="filter_code" value={filter_code} onChange={updatefilter_code}  />
                              <code>{filter_code_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Username</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" placeholder="Username" id="filter_username" value={filter_username} onChange={updatefilter_username}  />
                              <code>{filter_username_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="form-group row">
                            <label class="col-sm-4 col-form-label">Name</label>
                            <div class="col-sm-8">
                              <input type="text" class="form-control" placeholder="Arjun Kumar"   id="filter_name" value={filter_name} onChange={updatefilter_name}  />
                              <code>{filter_name_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                          <div class="col-md-4">
                            <button class="btn btn-primary" onClick={()=>{ setfilterval(1); getData(); }}>Apply Filters</button>
                          </div>
                        
                        
                      
                      </div>
                      <br/><br/>
                    
              
                            <hr/>                  
                            </div> 
                            

                    <div class="col-12" style={{marginBottom:"2rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                        {/* COLUMNS MANAGEMENT DROPDOWN START */}
                          <div class="dropdown">
                          <button class="btn btn-warning" onClick={()=>{ document.getElementById("filter-top-card").style.display="block"; }}><i class="mdi mdi-filter-outline"></i></button>
                        {/*}  <button class="btn btn-primary dropdown-toggle" style={{marginLeft:"1rem"}} type="button" id="dropdownMenuIconButton1" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="mdi mdi-table-large"></i>
                            </button> */}
                          
                          {/* COLUMNS MANAGEMENT DROPDOWN END */}

                          </div>
                          </div>
                          </div>


                    <div className="table-responsive"  id="invoice" ref={componentRef}>
                      <table className="table table-hover table-bordered">
                        <thead>
                          <tr >
                            <th><b>#</b></th>
                         {/*}   <th  style={{fontWeight:"bold"}} hidden={cd_col2_val==1} >Admin Id</th> */}
                            <th  style={{fontWeight:"bold"}} hidden={cd_col2_val==1} >Admin Code</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col4_val==1} >Name</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col5_val==1} >Username</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col6_val==1} >Remarks</th>               
                            <th  style={{fontWeight:"bold"}} hidden={cd_col7_val==1} >Status</th>
                            <th  style={{fontWeight:"bold"}} hidden={cd_col10_val==1} >Manage</th>                         
                          </tr>
                        </thead>
                        <tbody>
                        {
                       data.map((curElm,ind)=>{

                         return(
                         <>
                        <tr key={ind}>
                          <td>{ind + 1}</td>
                         {/*} <td>{curElm.Admin_id}</td> */}
                          <td>{curElm.Code}</td>
                          <td>{curElm.Name}</td>
                          <td>{curElm.Username}</td>
                          <td>{curElm.Admin_remarks}</td>
                          <td><label className="badge badge-success" hidden={curElm.Admin_status=="inactive"}>active</label>
                          <label className="badge badge-danger" hidden={curElm.Admin_status=="active"}>inactive</label></td>             
                          <td><button class="btn btn-primary" onClick={()=>{
                            //Edit Redirect
                            sessionStorage.setItem("EditId00",curElm.Admin_id);
                            window.location.replace("/spadminpanel-dashboard-edit-admin")
                          }}>Manage</button></td>        
            
                        </tr>
                        </>
                         )
                         }
					   
	                  		 )
                         }
                           </tbody>
                      </table>
                    </div>
                    
                    {/* PAGINATION SECTION START */}
                    <div>
                       <div class="col-12" style={{marginBottom:"2rem",marginTop:"1rem"}}>
                        <div class="template-demo d-flex justify-content-between">
                        <div></div>

                       
                          <div class="dropdown">
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber-1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-left-drop-circle text-success"></i></button>
                          <button class="btn" onClick={()=>{ const pgNumber=pageNumber+1; setpageNumber(pgNumber); getData();  }}><i class="mdi mdi-arrow-right-drop-circle text-success"></i></button>
                          </div>
                          </div>
                          </div>
                    </div>
                    {/* PAGINATION SECTION END */}
                  </div>
                </div>
              </div>

            {/* bpm TRANSACTIONS TABLE SECTION END */}

            <button type="button" style={{backgroundColor:"#196fb0",marginTop:"2rem",marginLeft:"2rem"}} class="btn btn-secondary btn-icon-text" onClick={handlePrint}> Print <i class="mdi mdi-file-document"></i>
            </button>
            <button class="btn btn-dark" style={{marginTop:"2rem",marginLeft:"2rem"}} onClick={getexcelData}><i class="mdi mdi-file-excel text-light"></i> Download</button>

           <br/><br/><br/>

            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
       {/*}   <footer className="footer">
            <div className="d-sm-flex justify-content-center justify-content-sm-between">
              <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i className="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
</>
);

//}
}
export default SP_admins;